import useWarehousesLoading from 'hooks/useWarehousesLoading'
import { selectWarehouses } from './warehousesSlice'
import useTranslation from 'hooks/useTranslation'
import { useHistory } from 'react-router-dom'
import { useReduxSelector } from 'store'
import Loading from 'components/Loading'
import React, { useEffect } from 'react'
import SlideShow from './SlideShow'
import './style.scss'

const Warehouses: React.FC = () => {
  const isLoading = useWarehousesLoading()
  const warehouses = useReduxSelector(selectWarehouses)

  const { push, replace } = useHistory()
  const { t } = useTranslation('warehouse')

  useEffect(() => {
    const firstWarehouseId = warehouses?.[0]?.objectId
    if (firstWarehouseId) {
      replace(`/warehouses/${firstWarehouseId}`)
    }
  }, [warehouses, replace])

  return (
    <div className='warehouses'>
      <div className='title'>
        <div>{t('myWarehouses')}</div>
        <div>{t('selectAWarehouseToManage')}</div>
      </div>

      <div className='warehouses__slides center'>
        <div>
          {(warehouses?.length > 0 || !isLoading)
            ? <SlideShow
              autoplay
              showInfo
              action={(id) => {
                push(`/warehouses/${id}`)
              }} />
            : <Loading middleOfPage />}
        </div>
      </div>
    </div>
  )
}

export default Warehouses